import Avatar from "@components/avatar"

const CompanyAvatar = ({company, ...restProps}) => {
  return (
    <Avatar img={company.logo} content={company.name} {...restProps}/>
  )
}

export default CompanyAvatar